import * as React from 'react';
import { UIHeading4, useDeviceType } from '@cian/ui-kit';
import cx from 'clsx';
import { ContactAvatarContext } from '../ContactAvatar/internal';
import { ContactMainInfo } from '../../../internal/components/ContactMainInfo';
import * as styles from './styles.module.css';

/**
 * Компонент для указания подконтакта в Контакте
 * Используется совместно с ContactCard
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 * В малой (до 374px) мобильной версии не выводятся иконки около имени,
 * а все элементы выстраиваются вертикально и центрируются
 */
export function Subcontact(_ref) {
  var title = _ref.title,
      name = _ref.name,
      href = _ref.href,
      target = _ref.target,
      onNameClick = _ref.onNameClick,
      nameIcons = _ref.nameIcons,
      avatar = _ref.avatar,
      labels = _ref.labels;
  var deviceType = useDeviceType();
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['subcontact'], deviceType === 'phone' && styles['mobile'])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['avatar']
  }, /*#__PURE__*/React.createElement(ContactAvatarContext.Provider, {
    value: {
      size: 48
    }
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: styles['contact']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-info']
  }, /*#__PURE__*/React.createElement(ContactMainInfo, {
    NameHeadingComponent: UIHeading4,
    title: title,
    name: name,
    href: href,
    target: target,
    onNameClick: onNameClick,
    nameIcons: nameIcons
  })), labels));
}